import { Deserializable } from './deserializable.model';
import { ProductInstance } from './product-instance.model';

export const ProductTitles = {
  photograhy: 'Professional Photography',
  brochure: 'Brochure',
};

export const ProductCodes = {
  photography: '101',
  brochure: '104',
};

export class PackageInstance implements Deserializable<PackageInstance> {
  title: string;
  description: string;
  code: string;
  thumbnailUri: string;
  price: number;
  position: number;
  products: ProductInstance[] = [];

  constructor(data?: any) {
    this.deserialize(data || {});
    const productObjects = [];
    this.products.forEach((prod) => {
      productObjects.push(new ProductInstance(prod));
    });
    this.products = productObjects;
  }

  deserialize(input: any): PackageInstance {
    Object.assign(this, input);

    if (input.products) {
      this.products = input.products.map((pr) => new ProductInstance(pr));
    }

    return this;
  }

  getPhotographyProduct() {
    return this.products.find((p) => p.code === ProductCodes.photography);
  }

  getBrochureProduct() {
    return this.products.find((p) => p.code === ProductCodes.brochure);
  }

  getProduct(productCode: string): ProductInstance {
    return this.products.find((aProduct) => aProduct.code === productCode);
  }
}
